// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAbfQe6L9Mmu6c4Ncj-ywt_XHksib8h6_A",
  authDomain: "grillshack-f5e35.firebaseapp.com",
  projectId: "grillshack-f5e35",
  storageBucket: "grillshack-f5e35.firebasestorage.app",
  messagingSenderId: "275409365183",
  appId: "1:275409365183:web:cb0237210bf536d665fe0a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Firestore
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
